import { FormLabel } from "@chakra-ui/react";
import { ReactNode } from "react";
import { useFloatingField } from "./context";
import { sizeStyles } from "./sizeStyles";

interface FloatingLabelProps {
  children: ReactNode;
}

function FloatingLabel({ children }: FloatingLabelProps) {
  const { size, required, name, hasValue } = useFloatingField();
  const styles = sizeStyles[size];

  return (
    <FormLabel
      className="cds-floating-label"
      htmlFor={name}
      position="absolute"
      top={styles.labelBaseTop}
      left={2}
      color="gray.500"
      fontSize={size === "sm" ? "sm" : "md"}
      pointerEvents="none"
      transition="all 0.2s"
      transformOrigin="left top"
      transform={hasValue ? `scale(0.75) translateY(${styles.translateY})` : undefined}
      zIndex={2}
      m={0}
      pr={2}
    >
      {children}
      {required === false && (
        <span style={{ fontWeight: 400, fontSize: "calc(1em - 1px)", color: "#9CA3AF" }}> (optional)</span>
      )}
    </FormLabel>
  );
}

export default FloatingLabel;
